import { fire, auth } from "../../firebase/index";
import { confirmAlert } from "react-confirm-alert";
import { customLog } from "../../variables/Variables";
const db = fire.database();

const getUserDetails = async (callback) => {
  await db
    .ref("registeredIndustrialUsersOnPlatform/" + auth.currentUser.uid)
    .once("value")
    .then((snapshot) => {
      if (snapshot.exists()) {
        const userDetails = snapshot.val();
        callback(userDetails);
      }
    });
};

const getSuperAdminID = async (email, callback) => {
  const db = fire.database();

  db.ref("groupAccounts")
    .once("value")
    .then((snapshot) => {
      if (snapshot.exists()) {
        snapshot.forEach((superAdmin) => {
          const superAdminID = superAdmin.key;

          db.ref("groupAccounts")
            .child(superAdminID)
            .child("members")
            .once("value")
            .then((members) => {
              members.forEach((member) => {
                let memberVal = member.val();
                if (memberVal.memberEmail === email) {
                  callback(superAdminID);
                }
              });
            });
        });
      }
    })
    .catch((err) => customLog(err));
};

const getUserNickName = (superAdminID, callback) => {
  const db = fire.database();

  db.ref("groupAccounts")
    .child(superAdminID)
    .child("members")
    .once("value")
    .then((members) => {
      members.forEach((member) => {
        let memberVal = member.val();
        let memberUid = memberVal.memberUid;

        if (memberVal.memberEmail === auth.currentUser.email) {
          if (
            memberVal.memberName !== undefined ||
            memberVal.memberName !== null ||
            memberVal.memberName !== ""
          ) {
            db.ref("groupAccounts")
              .child(superAdminID)
              .child("members")
              .child(memberUid)
              .once("value")
              .then((snapshot) => {
                callback(snapshot.val().memberName);
              });
          } else {
            db.ref("registeredIndustrialUsersOnPlatform")
              .child(auth.currentUser.uid)
              .once("value")
              .then((snapshot) => {
                let snapVal = snapshot.val();
                let userName = snapVal.name;

                db.ref("groupAccounts")
                  .child(superAdminID)
                  .child("members")
                  .child(memberUid)
                  .set({
                    memberName: userName,
                  });

                callback(userName);
              });
          }
        }
      });
    });
};

const promptSaveConfirmation = async (
  newUserName,
  newCompanyName,
  newMemberName,

  callback
) => {
  const saveTitle = "Save changes";
  const saveMessage = "Confirm save changes ?";
  const saveButtons = [
    {
      label: "Confirm",
      onClick: async () => {
        let updateComName = await updateCompanyName(newCompanyName);
        let updateUName = await updateUserName(newUserName);

        let updateMName = await updateNewMemberName(newMemberName);

        // customLog(updateComName);
        // customLog(updateUName);

        if (updateComName && updateUName && updateMName) {
          callback(true);
        } else {
          callback(false);
        }
      }, //onClick
    },
    {
      label: "Cancel",
      onClick: () => {
        return false;
      },
    },
  ]; //delButton

  confirmAlert({
    title: saveTitle,
    message: saveMessage,
    buttons: saveButtons,
  });
};

const updateUserName = async (newUserName) => {
  await db
    .ref("registeredIndustrialUsersOnPlatform/" + auth.currentUser.uid)
    .update({
      name: newUserName,
    });

  await db
    .ref("userFriendListIndustrial")
    .once("value")
    .then((snapshot) => {
      if (snapshot.exists()) {
        snapshot.forEach((eachUser) => {
          const eachUserVal = eachUser.val();
          for (const userFriend in eachUserVal) {
            const eachFriendDetails = eachUserVal[userFriend];
            customLog(eachFriendDetails.friendEmail);
            if (eachFriendDetails.friendEmail === auth.currentUser.email) {
              customLog(eachFriendDetails);
              db.ref(
                "userFriendListIndustrial/" + eachUser.key + "/" + userFriend
              ).update({
                friendName: newUserName,
              });
            }
          }
        });
      }
    });

  return true;
};

const updateCompanyName = async (newCompanyName) => {
  await db
    .ref("registeredIndustrialUsersOnPlatform/" + auth.currentUser.uid)
    .update({
      company: newCompanyName,
    });

  return true;
};

//update username (for those who are Super Admin only)
const updateNewMemberName = async (newMemberName) => {
  await db
    .ref("groupAccounts")
    .child(auth.currentUser.uid)
    .child("members")
    .once("value")
    .then((snapshot) => {
      snapshot.forEach((snapshot) => {
        let snapshotVal = snapshot.val();
        let memberUID = snapshotVal.memberUid;

        if (snapshotVal.memberEmail === auth.currentUser.email) {
          if (
            snapshotVal.memberName !== undefined ||
            snapshotVal.memberName !== null ||
            snapshotVal.memberName !== ""
          )
            db.ref("groupAccounts")
              .child(auth.currentUser.uid)
              .child("members")
              .child(memberUID)
              .update({
                memberName: newMemberName,
              });
        }
      });
    });
  return true;
};

export {
  getUserDetails,
  getUserNickName,
  getSuperAdminID,
  promptSaveConfirmation,
};
